import { downloadReport, userIcon } from "../../assets/images";
import { UiButton, UiProfileModel, UiRangePicker, UiSearch, UiSelect, UiTab, UiTable, UiWarningRating } from "../../components";
import { lang_en_US as translation } from "../../config";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { tablePageSizeOptions } from "../../utils/appUtils";
import ReactToPrint from "react-to-print";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import { CONSULTATION_HEADER_COLUMNS, consultationTabData } from "./config";
import { useSelector } from "react-redux";

const Consultation = ({
    handleDateChange,
    handlePagination,
    handleConsultationCancel,
    handleConsultationTabChange,
    consultationData,
    allConsultationData,
    consultation,
    consultationActionRender,
    handleSearch,
    handleMonthChange,
    handleConsultationReport,
    setConsultationBooleans,
    getConsultationDropdown,
    consultationRef,
    minutesConfig,
    selectedMinute,
    handleMinuteChages
}) => {
    const keywords = translation?.lawyerManagement;
    const consultationIfo = allConsultationData?.result?.consultationCumulativeResponse;
    const lawyerInformation = allConsultationData?.result?.consultationCumulativeResponse?.lawyerResponse;
    const customerInformation = allConsultationData?.result?.consultationCumulativeResponse?.customerResponse;
    const configResults = useSelector((state) => state?.configAction?.configData);
    const configGstPercentage = configResults?.find((detail) => detail?.configId === "lawyerFeePercentage")?.configuration?.[0] || 0;
    return <>
        <div className="flexible">
            <div style={{ display: "flex", gap: "10px" , alignItems: "center" }}>
                <ArrowLeftOutlined onClick={handleConsultationCancel} />
                 <h6 style={{ padding: "10px", margin: 0 }}>Consultation</h6>
            </div>
            <div className="flexible">
                {Boolean(minutesConfig && handleMinuteChages) && (
                    <UiSelect value={selectedMinute || null} options={minutesConfig} onChange={(minutes) => handleMinuteChages(minutes)} placeholder={"Select Min"} style={{width:100}}/>
                )}
                <DatePicker picker="month" format="MMM" value={consultation?.month||null} onChange={(month) => handleMonthChange(month, "consultation")} style={{ height: 32, width: 150, borderRadius: 6 }} disabledDate={(current) => current && current > dayjs().endOf("day")}/>
                <UiRangePicker value={consultation?.fromDate && consultation?.toDate ? [dayjs(consultation?.fromDate), dayjs(consultation?.toDate)] : null} onChange={(date) => handleDateChange(date, "consultation")} disabledDate={(current) => current && current > dayjs().endOf("day")}/>
                <UiSearch placeholder={keywords?.consultationSearch} value={consultation?.searchFilter} onChange={(search) => handleSearch(search.target.value, "consultation")} />
                {
                    !consultation?.isCustomer && <ReactToPrint
                        trigger={() => <UiButton type="primary" onClick={handleConsultationReport}><img src={downloadReport} alt="" /> Download Report</UiButton>}
                        content={() => consultationRef.current}
                        onAfterPrint={() => setConsultationBooleans(prev => ({ ...prev, isConsultationReportOpen: false }))}
                        pageStyle={`
                        @page {
                            size: A4 landscape !important;
                            margin: 8mm !important;
                        }
                        @media print {
                            @page {
                                size: A4 landscape !important;
                                margin: 8mm !important;
                            }
                        }
                        body {
                            -webkit-print-color-adjust: exact;
                            print-color-adjust: exact;
                        }
                            .consultation-Report::before{
                                content: "";
                                position: fixed;
                                top: 0;
                                left: 0;
                                right: 0;
                                bottom: 0;
                                border: 2px solid #005D60;
                                z-index: 9999;
                                pointer-events: none;
                            }
                    `}
                    />
                }
            </div>
        </div>
        <div style={{ backgroundColor: "#005D600F", height: "70px" }}>
            <div className="flexible">
                <div className="flexible">
                    <div style={{ display: "flex", justifyContent: "space-around", padding: "0px 10px", gap: "10px" }}>
                        {
                            !consultation?.profile|| consultation?.profile?.includes("null")||consultation?.profile?.includes("undefined") ?<img src={userIcon} style={{width: "50px",height: "50px",borderRadius: "50%",objectFit: "cover"}} alt=""/>:<UiProfileModel imageUrl={consultation?.profile} />
                        }
                        <div>
                            {
                                lawyerInformation ? <h3 className="lawerInfo-detail" style={{paddingTop:"8px"}}>{lawyerInformation?.salutation} {lawyerInformation?.firstName} {lawyerInformation?.middleName} {lawyerInformation?.lastName}</h3> :
                                    <h3 className="lawerInfo-detail" style={{paddingTop:"5px"}}>{customerInformation?.salutation} {customerInformation?.firstName} {customerInformation?.middleName} {customerInformation?.lastName}</h3>
                            }
                            <div style={{ padding: "5px 0px" }}>
                                <UiWarningRating count={lawyerInformation ? lawyerInformation?.warningCountAfterActive : customerInformation?.warningCountAfterActive} />
                            </div>
                        </div>
                    </div>
                    {
                        lawyerInformation && <div>
                            <div className="flexible">
                                <div style={{ borderRight: "1px solid gray", padding: "5px 10px" }}>
                                    <small className="information-header">Revenue</small>
                                    <h4 className="lawerInfo-detail">{consultationIfo?.revenue}</h4>
                                </div>
                                <div style={{ borderRight: "1px solid gray", padding: "5px 10px" }}>
                                    <small className="information-header">Total Earnings</small>
                                    <h4 className="lawerInfo-detail">{consultationIfo?.totalEarning}</h4>
                                </div>
                                <div style={{borderRight: "1px solid gray", padding: "5px 10px" }}>
                                    <small className="information-header">Total Penalty</small>
                                    <h4 className="lawerInfo-detail">{consultationIfo?.penaltyAmount}</h4>
                                </div>
                                <div style={{ padding: "5px 5px" }}>
                                    <small className="information-header">Total Gst Amount</small>
                                    <h4 className="lawerInfo-detail">{consultationIfo?.totalGstAmount}</h4>
                                </div>
                            </div>
                        </div>
                    }
                {
                        customerInformation && <div>
                            <div className="flexible">
                                <div style={{ borderRight: "1px solid gray", padding: "5px 10px" }}>
                                    <small className="information-header">Revenue</small>
                                    <h4 className="lawerInfo-detail">{consultationIfo?.revenue}</h4>
                                </div>
                                <div style={{borderRight: "1px solid gray", padding: "5px 10px" }}>
                                    <small className="information-header">Total Refund</small>
                                    <h4 className="lawerInfo-detail">{consultationIfo?.totalRefundAmount}</h4>
                                </div>
                                 <div style={{ borderRight: "1px solid gray", padding: "5px 10px" }}>
                                    <small className="information-header">Total Spend</small>
                                    <h4 className="lawerInfo-detail">{consultationIfo?.totalSpend}</h4>
                                </div>
                                 <div style={{ padding: "5px 10px" }}>
                                    <small className="information-header">Total Gst amount</small>
                                    <h4 className="lawerInfo-detail">{consultationIfo?.totalGstAmount}</h4>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <div className="flexible">
                    <div>
                        <small className="information-header">Total Cons.</small>
                        <h4 className="lawerInfo-detail">{consultationIfo?.totalConsultation}</h4>
                    </div>
                    <div>
                        <small className="information-header">Cancelled Cons.</small>
                        <h4 className="lawerInfo-detail">{consultationIfo?.totalCancelConsultation}</h4>
                    </div>
                </div>
            </div>
        </div>
        <div style={{ padding: "10px 0px" }}>
            <UiTab tabs={consultationTabData} activeTabKey={consultation?.activeTabKey} onChange={handleConsultationTabChange} count={allConsultationData?.result?.consultationCumulativeResponse?.consultationResponsePage?.totalElements} />
            <UiTable
                dataSource={consultationData}
                scroll={{ x: 'max-content' }}
                columns={CONSULTATION_HEADER_COLUMNS({ consultationActiveTab: consultation?.activeTab, consultationActionRender, getConsultationDropdown, configGstPercentage })}
                pagination={{
                    pageSize: consultation?.size,
                    current: consultation?.page + 1,
                    pageSizeOptions: tablePageSizeOptions,
                    showSizeChanger: true,
                    total: allConsultationData?.result?.consultationCumulativeResponse?.consultationResponsePage?.totalElements,
                    onChange: (page, size) => handlePagination(page, size, "consultation")
                }}
            />
        </div>
    </>
};
export default Consultation